import { useReducer, useEffect } from 'react'
import api, { ITicketDetails } from '@api'
import { Toaster } from '@ui'

enum Actions {
  LOAD,
  UPDATE,
}

interface LoadStartAction {
  type: Actions.LOAD
  ticket: ITicketDetails
}

interface UpdateAction {
  type: Actions.UPDATE
  ticket: ITicketDetails
}

type Action = LoadStartAction | UpdateAction

interface State {
  isLoading: boolean
  id: string
  ticket: ITicketDetails | null
}

function reducer(state: State, action: Action) {
  switch (action.type) {
    case Actions.LOAD:
      return {
        ...state,
        ticket: action.ticket,
        isLoading: false,
      }
    case Actions.UPDATE:
      return {
        ...state,
        ticket: action.ticket,
      }
    default:
      return state
  }
}

let persistedState: ITicketDetails | null = null

interface UseTicket extends State {
  update: (ticket: ITicketDetails) => void
}

export default function useTicket(id: string): UseTicket {
  const [state, dispatch] = useReducer(reducer, {
    id,
    ticket: persistedState && persistedState.id === id ? persistedState : null,
    isLoading: true,
  })

  useEffect(() => {
    api.ticket
      .details(state.id)
      .then((ticket) =>
        dispatch({
          type: Actions.LOAD,
          ticket,
        })
      )
      .catch((error) => Toaster.fail({ message: error.message }))
  }, [state.id])

  useEffect(() => {
    persistedState = state.ticket
  })

  return {
    ...state,
    update: (ticket: any) => dispatch({ type: Actions.UPDATE, ticket }),
  }
}
